export default [
    {
        path: 'procedimento',
        component: () => import(/* webpackChunkName: 'apac-procedimento' */ '@/views/apac/procedimento/Index'),
        redirect: 'procedimento/index',
        children: [
            {
                name: 'apac-procedimento-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'apac-procedimento' */ '@/views/apac/procedimento/List.vue'),
            },
            {
                name: 'apac-procedimento-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'apac-procedimento' */ '@/views/apac/procedimento/Form.vue'),
            },
        ],
    },
]